import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import ThreeRightDirectedArrows from "../../icon-components/three-right-directed-arrows";

var ThreeArrowsIcon = function ThreeArrowsIcon(_ref) {
  var reversed = _ref.reversed,
      isHidden = _ref.isHidden;
  var iconsClasses = cx({
    'MoveCountryButton-icons': true,
    'MoveCountryButton-reverse': reversed,
    hide: isHidden
  });
  return React.createElement("div", {
    className: iconsClasses
  }, React.createElement(ThreeRightDirectedArrows, null));
};

ThreeArrowsIcon.propTypes = {
  reversed: PropTypes.bool.isRequired,
  isHidden: PropTypes.bool.isRequired
};
export default ThreeArrowsIcon;